import React from "react";
import Frame from "../assets/icons/Frame.svg";
const NoData = ({ msg }) => {
  return (
    <>
      <div
        className="frame_not"
        style={{
          width: "100%",
          display: "flex",
          flexDirection: "column",
          gap: "30px",
          alignItems: "center",
          height: "80vh",
        }}
      >
        <img style={{ width: "30vw" }} src={Frame} alt="" />
        <div className="no_data">
          <p
            style={{
              color: "white",
              fontSize: "20px",
              textAlign: "center",
              fontWeight: "600",
              fontFamily: "var(--primary-font-family)",
            }}
          >
            {msg}
          </p>
        </div>
      </div>
    </>
  );
};

export default NoData;
